<div *ngFor="let option of options; index as i">
  <div class="container pointer" (click)="check(i, option)">
    <label class="checkbox-container" [ngClass]="{ 'checked': option.checked }">
      <input type="checkbox" [(ngModel)]="option.checked" name="" />
      <span class="custom-checkbox">
        <nb-icon class="check-icon" icon="check" pack="icomoon"></nb-icon>
      </span>
    </label>
    <h6 class="pointer global-transition">{{ 'view_translations.' + option.label | translate}}</h6>
  </div>
  <ng-container *ngIf="option.additionalTemplate && option.checked && option.additionalTemplate === 'jsParams'">
    <div class="inputs-wrapper">
      <div *ngFor="let param of option.additionalTemplateValues" class="single-input">
        <app-single-parameter-input (emitValue)="getParameterValue($event)" [configurationData]="param"></app-single-parameter-input>
      </div>
    </div>
  </ng-container>
  <ng-container *ngIf="option.additionalTemplate && option.checked && option.additionalTemplate === 'trackingParams'">
    <div class="inputs-wrapper">
      <div *ngFor="let param of option.additionalTemplateValues" class="single-input">
        <app-single-parameter-input (emitValue)="getParameterValue($event)" [configurationData]="param"></app-single-parameter-input>
      </div>
    </div>
  </ng-container>
</div>
